let inject = [
  '$scope',
  'SharedService',
  'HomeService',
  '$state',
  '$rootScope',
  '$window',
  '$stateParams',
  'CategoryService',
  '$timeout',
  'MetatagService'
];

class HomeController {
  constructor($scope, SharedService, HomeService, $state, $rootScope, $window, $timeout, MetatagService) {
    this.$state = $state;
    this.$scope = $scope;
    this.$window = $window;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.SharedService = SharedService;
    this.HomeService = HomeService;
    this.pageName = "PAG-1";
    this.postByCategory = [];
    this.company = "HINDU"
    this.SharedService.getCMSBanners(this.pageName, __env.adaptative ? 1 : 0).then(response => {
      this.cmsData = response;
      this.shCtrl.setTags(this.cmsData.seo);

    });
    this.$rootScope.$emit('onChangeCompany', '');
  }

  $onInit() {
    this.getBlogs();
  }

  getBlogs() {
    this.HomeService.getPostByCategory(this.company).then(responsePostByCategory => {
      this.postByCategory = responsePostByCategory.posts;
    });

  }


}

HomeController.$inject = inject;

export default HomeController;




/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/home/home.controller.js
 **/